// Static site data for Pond & Garden Maintenance Services
import {
  Droplets,
  Fish,
  Filter,
  Waves,
  Leaf,
  Sprout,
  Scissors,
  Flower2,
  TreeDeciduous,
  Wrench,
  Recycle,
  Shovel,
  Handshake,
  MapPin,
  CalendarClock,
  PoundSterling,
  Award,
  BadgeCheck,
} from "lucide-react";

export const BUSINESS = {
  name: "Pond & Garden Maintenance Services",
  short: "Pond & Garden",
  tagline: "Bringing Life Back To Your Outdoor Spaces",
  phone: "07857 469328",
  phoneTel: "+447857469328",
  email: "nwpondsandgardens@outlook.com",
  areas: [
    "East Grinstead",
    "Crawley",
    "Haywards Heath",
    "Forest Row",
    "Lingfield",
    "Horley",
  ],
  social: {
    instagram: "https://www.instagram.com/pondandgarden_maintenance/",
    facebook: "https://www.facebook.com/profile.php?id=61580533468849",
  },
  whatsapp: "447857469328",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/du8mu78w_WhatsApp%20Image%202026-06-25%20at%2012.47.01.jpeg";

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/2da76dfd-73c4-4071-95e3-2453f9987223/images/e88d52aff7edb4ab58349259f1f7beb5542c4148e5563b4ff93050026da3993f.png";

export const HERO_VIDEO = "/videos/koi-pond.mp4";
export const HERO_VIDEO_POSTER = "/videos/koi-pond-poster.jpg";

export const BLOG_IMAGE =
  "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/9xxhfglc_WhatsApp%20Image%202026-06-25%20at%2013.20.48.jpeg";

export const ABOUT = {
  eyebrow: "Who we are",
  heading: "Caring for ponds and gardens across Sussex.",
  body: [
    "We specialise in restoring and maintaining ponds and gardens to keep outdoor spaces looking their best throughout the year. Whether you need a one-off clean-up or regular maintenance, we provide reliable, friendly, and professional service.",
    "From full pond cleans and relining to weeding, pruning and seasonal garden upkeep — we treat every outdoor space as if it were our own.",
  ],
  image:
    "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/hns6j4e9_WhatsApp%20Image%202026-07-14%20at%2008.39.36.jpeg",
  stats: [
    { value: "7+", label: "Areas covered" },
    { value: "Silver Gilt", label: "Award-winning" },
    { value: "All year", label: "Maintenance" },
  ],
};

export const TRUST_ITEMS = [
  { label: "Fair Pricing", desc: "Honest prices, up front", icon: PoundSterling },
  { label: "Local Business", desc: "Based in East Grinstead", icon: MapPin },
  { label: "Reliable & Friendly", desc: "Professional every time", icon: Handshake },
  { label: "One-Off & Regular", desc: "Flexible scheduling", icon: CalendarClock },
];

export const POND_SERVICES = {
  id: "pond",
  title: "Pond Services",
  icon: Droplets,
  image:
    "https://images.pexels.com/photos/32072434/pexels-photo-32072434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  blurb:
    "Keeping your pond clean, healthy and thriving — from routine upkeep to full restorations.",
  items: [
    { label: "Full pond cleans", icon: Droplets },
    { label: "Pond maintenance", icon: Waves },
    { label: "Filter cleaning", icon: Filter },
    { label: "Pump cleaning", icon: Wrench },
    { label: "Surface skimming", icon: Waves },
    { label: "Plant maintenance", icon: Leaf },
    { label: "Spring pond cleans", icon: Sprout },
    { label: "Autumn pond cleans", icon: Leaf },
    { label: "Pond relining", icon: Shovel },
    { label: "General pond repairs", icon: Wrench },
  ],
};

export const GARDEN_SERVICES = {
  id: "garden",
  title: "Garden Services",
  icon: Leaf,
  image:
    "https://customer-assets-agu9un31.emergentagent.net/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/ca3n2nij_van.jpeg",
  blurb:
    "Keeping your garden tidy, healthy and looking its best through every season.",
  items: [
    { label: "Weeding", icon: Sprout },
    { label: "Pruning", icon: Scissors },
    { label: "Planting", icon: Flower2 },
    { label: "Garden tidying", icon: Recycle },
    { label: "Seasonal maintenance", icon: TreeDeciduous },
    { label: "General garden upkeep", icon: Leaf },
    { label: "Regular maintenance visits", icon: CalendarClock },
  ],
};

export const SERVICE_OPTIONS = [
  "Full pond clean",
  "Pond maintenance",
  "Pond relining",
  "Pond repairs / filters & pumps",
  "Garden maintenance & tidy-up",
  "Weeding & pruning",
  "Planting",
  "Regular maintenance visits",
  "Other / Multiple",
];

export const WHY_CHOOSE = [
  {
    title: "Reliable & Friendly Service",
    desc: "Turn up when we say we will, work hard and leave everything tidy.",
    icon: Handshake,
  },
  {
    title: "Local East Grinstead Business",
    desc: "Proudly serving East Grinstead and the surrounding Sussex area.",
    icon: MapPin,
  },
  {
    title: "One-Off & Regular Maintenance",
    desc: "Book a single visit or set up a schedule that suits you.",
    icon: CalendarClock,
  },
  {
    title: "Affordable Pricing",
    desc: "Fair, honest prices with no hidden costs — quoted up front.",
    icon: PoundSterling,
  },
  {
    title: "Experienced Pond & Garden Care",
    desc: "The right know-how to keep your ponds and gardens thriving.",
    icon: Award,
  },
  {
    title: "Friendly Advice",
    desc: "Happy to talk through the best options for your space.",
    icon: BadgeCheck,
  },
];

// Project gallery — owner's real photos only.
export const GALLERY = [
  {
    id: "pond-clean",
    title: "Pond Clean",
    tag: "Pond",
    src: "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/5y0i9y82_WhatsApp%20Image%202026-06-25%20at%2012.47.03%20%281%29.jpeg",
    span: "auto",
  },
  {
    id: "stream",
    title: "Stream & Rockery Clean",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/9v30lio3_WhatsApp%20Image%202026-06-25%20at%2013.20.48%20%281%29.jpeg",
    span: "auto",
  },
  {
    id: "patio",
    title: "Patio Leaf Clearance",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/e69x2jvd_WhatsApp%20Image%202026-06-25%20at%2012.47.03.jpeg",
    span: "auto",
  },
  {
    id: "lawn",
    title: "Lawn & Garden Clearance",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/wst665vc_WhatsApp%20Image%202026-06-25%20at%2012.47.02.jpeg",
    span: "auto",
  },
  {
    id: "garden-pond-restoration",
    title: "Garden Pond Restoration",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/tbut6ypg_WhatsApp%20Image%202026-07-14%20at%2008.39.34.jpeg",
    span: "auto",
  },
  {
    id: "wildlife-pond-clearup",
    title: "Wildlife Pond Clear-Up",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/pc8qpfbl_WhatsApp%20Image%202026-07-14%20at%2008.39.34%20%282%29.jpeg",
    span: "auto",
  },
  {
    id: "lily-pond-clean",
    title: "Lily Pond Clean",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/y1b7i5is_WhatsApp%20Image%202026-07-14%20at%2008.39.34%20%281%29.jpeg",
    span: "auto",
  },
  {
    id: "pond-cleanout-project",
    title: "Pond Clean-Out",
    tag: "Project",
    slides: [
      "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/aia4tiad_WhatsApp%20Image%202026-07-14%20at%2008.39.35%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/bvstugfc_WhatsApp%20Image%202026-07-14%20at%2008.39.35%20%282%29.jpeg",
    ],
    span: "auto",
  },
  {
    id: "silver-gilt-award",
    title: "Silver Gilt — Horticultural Trade Stand",
    tag: "Award",
    src: "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/aha7dm63_WhatsApp%20Image%202026-07-14%20at%2008.39.35%20%284%29.jpeg",
    span: "auto",
  },
  {
    id: "raised-bed-restoration",
    title: "Raised Bed Restoration",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/wyssp8hz_WhatsApp%20Image%202026-07-14%20at%2008.39.36%20%282%29.jpeg",
    span: "auto",
  },
  {
    id: "pond-restoration-project",
    title: "Full Pond Restoration",
    tag: "Project",
    slides: [
      "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/3iay7xpq_WhatsApp%20Image%202026-07-14%20at%2008.39.35%20%283%29.jpeg",
      "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/rh95akpp_WhatsApp%20Image%202026-07-14%20at%2008.39.36%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/cd0f8x5x_WhatsApp%20Image%202026-07-14%20at%2008.39.35.jpeg",
    ],
    span: "auto",
  },
  {
    id: "wildlife-pond-build",
    title: "New Wildlife Pond Build",
    tag: "Before & After",
    src: "https://customer-assets.emergentagent.com/job_f1ad8841-eab3-431b-81bc-a738cdf4399f/artifacts/7ahgqlab_WhatsApp%20Image%202026-07-14%20at%2008.39.36%20%283%29.jpeg",
    span: "auto",
  },
];

export const VIDEO_SHOWCASE = {
  title: "Watch us in action",
  caption:
    "A short clip from a recent garden clean-up — clearing away leaves and debris to leave the garden neat and tidy.",
  location: "East Grinstead",
  poster: "/posters/garden-video.jpg",
  src: "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/oftsegct_WhatsApp%20Video%202026-06-25%20at%2013.25.58.mp4",
};

// Before / after pairs. Stock imagery — to be replaced with owner photos.
export const BEFORE_AFTER = [
  {
    id: "pond-restore",
    title: "Pond Restoration",
    location: "East Grinstead",
    description:
      "A tired, murky pond fully cleaned and restored to clear, healthy water that shows off the fish and plants.",
    before:
      "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/bt9rbjs2_WhatsApp%20Image%202026-06-25%20at%2012.47.03%20%282%29.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/5y0i9y82_WhatsApp%20Image%202026-06-25%20at%2012.47.03%20%281%29.jpeg",
  },
  {
    id: "pond-clearout",
    title: "Overgrown Pond Clear-Out",
    location: "West Sussex",
    description:
      "A neglected, moss-covered pond choked with sludge and leaves — fully cleared out, re-edged and finished with a clean pebble beach.",
    before:
      "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/t6bcd2il_WhatsApp%20Image%202026-06-25%20at%2013.13.35.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_2da76dfd-73c4-4071-95e3-2453f9987223/artifacts/y1vsrz8v_WhatsApp%20Image%202026-06-25%20at%2013.13.36.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Tony Moore",
    location: "via Facebook",
    rating: 5,
    text: "Nathan has just done a great job for us digging a wildlife pond and using his expertise to set a good profile and lay it out with underlay and liner. Very pleased with the results, he is very knowledgeable and a hard worker. Highly recommended.",
  },
  {
    name: "Kathryn Hibberd-Little",
    location: "via Facebook",
    rating: 5,
    text: "Highly recommend Nathan and his pond services! My mum was looking for a new pond maintenance company and someone to fix a fault with her pond pump. Nathan was able to advise over the phone and attended her property promptly (despite torrential rain!). He had her pond pump working again very quickly and we have organised regular maintenance visits going forward. Really knowledgeable and passionate about his work.",
  },
  {
    name: "Sue Mundy",
    location: "via Facebook",
    rating: 5,
    text: "Nathan recently relined our leaky pool. He was very professional and made an excellent job. All our fish are now very happy!",
  },
  {
    name: "Cj BeeBee",
    location: "via Facebook",
    rating: 5,
    text: "I cannot recommend Nathan enough! Very experienced and knowledgeable. Our garden is transformed.",
  },
  {
    name: "Belinda Jacques",
    location: "via Facebook",
    rating: 5,
    text: "Very happy with the recent pond work done for me. Efficient, tidy and knowledgeable. Would recommend.",
  },
];

export const SERVICE_AREAS = [
  "East Grinstead",
  "Crawley",
  "Haywards Heath",
  "Forest Row",
  "Lingfield",
  "Horley",
  "& surrounding areas",
];

export const MAP_EMBED =
  "https://www.google.com/maps?q=East+Grinstead,+West+Sussex&output=embed";

// Blog / advice articles. Add new posts by copying an entry below.
export const BLOG_POSTS = [
  {
    slug: "meet-nathan-pond-garden-maintenance",
    title: "Meet Nathan — The Face Behind Pond & Garden",
    excerpt:
      "The person you'll actually meet when you book a visit. Here's a little about Nathan, what he does, and the care he brings to every pond and garden.",
    cover: ABOUT.image,
    date: "2026-07-07",
    readTime: "3 min read",
    category: "About Us",
    body: [
      { type: "p", text: "When you get in touch with Pond & Garden Maintenance Services, it's Nathan who turns up at your door — no call centres, no middlemen, just a friendly local who genuinely cares about outdoor spaces." },
      { type: "h", text: "What Nathan does" },
      { type: "p", text: "Nathan looks after ponds and gardens right across East Grinstead and the surrounding Sussex area. From full pond cleans, filter and pump servicing and relining, through to weeding, pruning, planting and seasonal garden tidy-ups — if it's outdoors and needs a bit of care, he's your man." },
      { type: "p", text: "Whether you need a one-off clean-up to get things back on track or regular visits to keep everything looking its best all year round, Nathan tailors the work to exactly what your space needs." },
      { type: "h", text: "The way he works" },
      { type: "p", text: "Nathan believes in doing the job properly. That means turning up when he says he will, working hard, and always leaving a space tidier than he found it. He treats every pond and garden as if it were his own — and it shows in the results." },
      { type: "p", text: "He'll always take a proper look first and talk through the work and pricing before anything begins, so you know exactly where you stand." },
      { type: "h", text: "Local, reliable and friendly" },
      { type: "p", text: "Being a local, independent business means Nathan builds real relationships with his customers — many of whom book him back season after season. He covers properties within approximately 30 minutes' travel of East Grinstead." },
      { type: "p", text: "Got a pond or garden that could use some attention? Get in touch — Nathan would be happy to help." },
    ],
  },
  {
    slug: "keeping-your-pond-healthy-all-year",
    title: "Keeping Your Pond Healthy All Year Round",
    excerpt:
      "From spring clean-ups to winter care, here's how to keep your pond water clear, your fish happy and your plants thriving through every season.",
    cover:
      "https://images.unsplash.com/photo-1696124506484-c47e5fbaead1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    date: "2026-06-20",
    readTime: "4 min read",
    category: "Pond Care",
    body: [
      { type: "p", text: "A healthy pond is about balance — the right amount of light, oxygen, plants and clean water working together. When that balance slips, you get green water, algae and stressed fish. The good news is that a little regular attention goes a long way." },
      { type: "h", text: "Spring: the big reset" },
      { type: "p", text: "Spring is the ideal time for a full pond clean. Clearing out the sludge and debris that built up over winter gives your pond a fresh start before the warmer months. It's also the perfect moment to check your pump and filter are running properly." },
      { type: "h", text: "Summer: stay on top of algae" },
      { type: "p", text: "Warm, sunny weather means algae can take hold quickly. Surface skimming, keeping the filter clean and making sure you have enough oxygenating plants all help keep the water clear without harsh chemicals." },
      { type: "h", text: "Autumn: keep the leaves out" },
      { type: "p", text: "Falling leaves are one of the biggest causes of murky water. Netting the pond or regularly skimming the surface stops leaves from sinking and rotting on the bottom." },
      { type: "h", text: "Winter: gentle care" },
      { type: "p", text: "In colder months your pond needs less attention, but it's worth keeping a small area free of ice so gases can escape and your fish stay healthy." },
      { type: "p", text: "Prefer to leave it to us? We offer one-off pond cleans and regular maintenance visits across East Grinstead and the surrounding area." },
    ],
  },
  {
    slug: "autumn-garden-clean-up-checklist",
    title: "The Autumn Garden Clean-Up Checklist",
    excerpt:
      "Autumn is the perfect time to tidy up and prepare your garden for the year ahead. Here's our simple checklist to get it looking its best.",
    cover:
      "https://images.unsplash.com/photo-1459478309853-2c33a60058e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    date: "2026-06-10",
    readTime: "3 min read",
    category: "Garden Tips",
    body: [
      { type: "p", text: "As the leaves start to fall, a good autumn tidy-up sets your garden up for a healthy spring. Here's what we focus on when we visit." },
      { type: "h", text: "Clear the leaves" },
      { type: "p", text: "Leaves left on the lawn block light and trap moisture, which can lead to patchy, mossy grass. Regular clearing keeps your lawn breathing and looking neat." },
      { type: "h", text: "Cut back and prune" },
      { type: "p", text: "Autumn is a great time to prune many shrubs and cut back spent perennials. This tidies the borders and encourages strong growth next year." },
      { type: "h", text: "Weed and mulch" },
      { type: "p", text: "Removing weeds now and adding a layer of mulch protects the soil over winter and gives your plants a head start when the weather warms up." },
      { type: "p", text: "Short on time? We handle full autumn clean-ups — from leaf clearance to pruning and general tidying — leaving your garden neat and ready for winter." },
    ],
  },
  {
    slug: "planning-your-spring-planting",
    title: "Planning Your Spring Planting",
    excerpt:
      "A little planning now means a garden full of colour later. Here are our favourite tips for a beautiful, easy-to-maintain spring display.",
    cover:
      "https://images.unsplash.com/photo-1728667088041-ee116cf57c6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    date: "2026-05-28",
    readTime: "3 min read",
    category: "Garden Tips",
    body: [
      { type: "p", text: "There's nothing quite like a garden bursting into colour in spring. With a bit of forward planning, you can enjoy a display that looks fantastic and doesn't demand hours of upkeep." },
      { type: "h", text: "Choose the right plants" },
      { type: "p", text: "Pick plants suited to your soil and how much sun each spot gets. Mixing perennials with a few seasonal bedding plants gives you reliable structure plus a splash of fresh colour each year." },
      { type: "h", text: "Prepare the beds" },
      { type: "p", text: "Clearing weeds and improving the soil before you plant makes a huge difference. Healthy soil means healthy plants that need less watering and feeding." },
      { type: "h", text: "Think about maintenance" },
      { type: "p", text: "Grouping plants with similar needs together makes watering and care much simpler. It's a small step that saves a lot of time later on." },
      { type: "p", text: "Want a hand? We offer planting and regular maintenance visits to keep your borders looking their best all season long." },
    ],
  },
];
